module.exports = __webpack_public_path__ + "img/icon_dialog_wechat_hover.792f9e28.png";